import { render, staticRenderFns } from "./SwitchPurchaseOrder.vue?vue&type=template&id=5ab6e5f1&"
import script from "./SwitchPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./SwitchPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports